export const REQUEST_GLOBAL_BANNER = 'offer/REQUEST_GLOBAL_BANNER';
export const RECEIVE_GLOBAL_BANNER = 'offer/RECEIVE_GLOBAL_BANNER';
export const REQUEST_POST_PREDICTION_BANNER =
    'offer/REQUEST_POST_PREDICTION_BANNER';
export const REQUEST_BETSLIP_OFFER = 'offer/REQUEST_BETSLIP_OFFER';
export const RECEIVE_BETSLIP_OFFER = 'offer/RECEIVE_BETSLIP_OFFER';
